import asyncComponent from '../util/asyncComponent'

/* warnung: webpack does some magic with the code splitting here
do not try to factor loading of dependenciees into a generalized function */

export const specialistRoutes = [
  {
    path: '/specialist/profile',
    component: asyncComponent(() => import('../Linkgua/Pages/Specialists/ProfilePage'))
  },
  {
    path: '/specialist/task/:taskId/feedback',
    component: asyncComponent(() => import('../Linkgua/Pages/Specialists/Tasks/TaskFeedbackPage'))
  },
  {
    path: '/specialist/task/:taskId/show',
    component: asyncComponent(() => import('../Linkgua/Pages/Specialists/Tasks/TaskShowPage'))
  },
  {
    path: '/specialist',
    component: asyncComponent(() => import('../Linkgua/Pages/Specialists/Dashboard'))
  }
]




// WEBPACK FOOTER //
// ./app/specialistRoutes.js